// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.48 6.25C1.85 5.92 2.24 5.62 2.65 5.35',
  'M6.56 3.86C9.35 3.44 12.29 4.24 14.52 6.25',
  'M3.78 8.82C4.21 8.43 4.68 8.12 5.17 7.87',
  'M10.36 7.66C11.02 7.92 11.65 8.31 12.22 8.82',
  'M5.89 11.16C6.4 10.7 7.03 10.44 7.67 10.37',
  'M7.94 13.44H8.06V13.56H7.94Z',
  'M2 2L14 14',
];
